import React from "react";
import useAppTranslation from "../../../hooks/useAppTranslation";

export default function PuzzleClearModal({ level, handleNextLevel }) {
  const { t } = useAppTranslation("components/utils/slidePuzzleLoading");

  return (
    <div className="success-modal-overlay">
      <div className="success-modal">
        <h2>{t("clearModal.title")}</h2>
        <div className="clear-info">
          <p>{t("clearModal.levelClear", { level })}</p>
          <div className="stars">
            {Array.from({ length: level }).map((_, i) => (
              <img
                key={i}
                src="/images/utils/loading/slidePuzzleLoading/star.svg"
                alt={t("alts.star")}
              />
            ))}
          </div>
        </div>
        <button className="next-level-btn" onClick={handleNextLevel}>
          {level < 3
            ? t("clearModal.nextLevel")
            : t("clearModal.restart")}
        </button>
      </div>
    </div>
  );
}
